import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/button';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const PromoBanner = () => {
  const [ref, isVisible] = useIntersectionObserver({ once: true, threshold: 0.1 });

  return (
    <section ref={ref} className="py-16">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={isVisible ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 0.6 }}
          className="relative h-48 rounded-2xl overflow-hidden"
        >
          {/* Background */}
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1557821552-17105176677c?w=1600&h=400&fit=crop)'
            }}
          />

          {/* Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-primary/90 to-primary/70" />

          {/* Content */}
          <div className="relative h-full flex flex-col items-center justify-center text-white text-center px-6">
            <h2 className="text-3xl sm:text-4xl font-bold mb-4">
              ¿Tienes alguna pregunta?
            </h2>
            <p className="text-lg mb-6 text-white/90">
              Nuestro equipo está aquí para ayudarte
            </p>
            <Button
              size="lg"
              variant="secondary"
              className="ripple"
            >
              Contacte con nosotros
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PromoBanner;